import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lp2-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() page: number;
  @Input() totalPages: number;
  @Input() arraySize: number;
  @Input() pageSize: number;

  @Output() pageChange = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (!this.totalPages && this.arraySize && this.pageSize) {
      this.totalPages = Math.ceil(this.arraySize / this.pageSize);
    } else {
      this.totalPages = 1;
    }
  }

  navigateToPreviousPage() {
    if (this.page === 1) {
      return;
    }
    this.page = this.page - 1;
    this.pageChange.emit(this.page);
  }

  navigateToNextPage() {
    if (this.page >= this.totalPages) {
      return;
    }
    this.page = this.page + 1;
    this.pageChange.emit(this.page);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/pagination/pagination.component.ts